import React from 'react';

import { FormHelperText, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FieldArray } from 'formik';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import TextFieldFormik from '../../../../../common/text_field';
import { isEmptyObject } from '../../../../../../core/utils/misc_utils';
import DetailsDialog from '../common/details_dialog';

const ProductsList = ({ formik, disabled }) => {
    const onRemoveProduct = (position) => {
        const positions = formik?.values?.positions;
        const index = positions?.findIndex(product => product?.position === position);

        if (index !== -1) {
            positions.splice(index, 1);
            formik.setFieldValue('positions', positions);
        }
    };

    return (
        <FieldArray
            name={ 'positions' }
            render={ () => (
                <Grid container gap={ 2 }>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={ { width: '5%' } }>Lp.</TableCell>
                                    <TableCell>Nazwa</TableCell>
                                    <TableCell align="center" style={ { width: '10%' } }>Liczba szt.</TableCell>
                                    <TableCell align="center" style={ { width: '8%' } }>Szczegóły pozycji</TableCell>
                                    <TableCell align="center" style={ { width: '10%' } }>Kaucja</TableCell>
                                    <TableCell align="center" style={ { width: '12%' } }>Cena sprzedaży
                                        [brutto]</TableCell>
                                    <TableCell align="center" style={ { width: '12%' } }>Cena ostateczna
                                        [brutto]</TableCell>
                                    {
                                        !disabled &&
                                        <TableCell align="center" style={ { width: '5%' } }>Usuń</TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    formik?.values?.positions?.map((product, index) => (
                                        <TableRow
                                            key={ index }
                                            hover
                                        >
                                            <TableCell>{ index + 1 }</TableCell>
                                            <TableCell>
                                                <TextFieldFormik
                                                    name={ `positions.${ index }.name` }
                                                    disabled/>
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextFieldFormik
                                                    name={ `positions.${ index }.quantity` }
                                                    type="number"
                                                    inputProps={ { min: '1', step: '1' } }
                                                    style={ { background: 'white' } }
                                                    disabled={ disabled }/>
                                                <FormHelperText error>
                                                    <span>
                                                        {
                                                            !isEmptyObject(formik?.errors?.products?.[index]?.quantity) &&
                                                            formik?.errors?.products?.[index]?.quantity
                                                        }
                                                    </span>
                                                </FormHelperText>
                                            </TableCell>
                                            <TableCell align="center">
                                                <DetailsDialog product={ product }/>
                                            </TableCell>
                                            <TableCell align="center">
                                                {
                                                    product?.depositAmount &&
                                                    <TextFieldFormik
                                                        name={ `positions.${ index }.depositAmount` }
                                                        type="number"
                                                        inputProps={ {
                                                            min: '0.01',
                                                            max: '100.00',
                                                            step: '0.01',
                                                            endAdornment: "none"
                                                        } }
                                                        style={ { background: 'white', suffix: "none" } }
                                                        disabled/>
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextFieldFormik
                                                    name={ `positions.${ index }.sellingPrice` }
                                                    type="number"
                                                    inputProps={ { min: '0.01', max: '100.00', step: '0.01' } }
                                                    style={ { background: 'white' } }
                                                    disabled/>
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextFieldFormik
                                                    name={ `positions.${ index }.shopAdminSellingPrice` }
                                                    type="number"
                                                    inputProps={ { min: '0.01', max: '100.00', step: '0.01' } }
                                                    style={ { background: 'white' } }
                                                    disabled={ disabled }/>
                                                <FormHelperText error>
                                                    <span>
                                                        {
                                                            !isEmptyObject(formik?.errors?.products?.[index]?.shopAdminSellingPrice) &&
                                                            formik?.errors?.products?.[index]?.shopAdminSellingPrice
                                                        }
                                                    </span>
                                                </FormHelperText>
                                            </TableCell>
                                            {
                                                !disabled &&
                                                <TableCell align="center">
                                                    <IconButton
                                                        onClick={ () => onRemoveProduct(product?.position) }
                                                        title="Usuń">
                                                        <RemoveCircleIcon/>
                                                    </IconButton>
                                                </TableCell>
                                            }
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <FormHelperText error>
                        <span>
                            {
                                !isEmptyObject(formik?.errors?.positions?.length) &&
                                formik?.errors?.positions
                            }
                        </span>
                    </FormHelperText>
                </Grid>
            ) }
        />
    );
};

export default ProductsList;
